import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useController } from 'react-hook-form';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import { useCurrentBlock } from '../../CurrentBlockProvider';
import { BlockSpecificPage } from '../../../lib/declarations/BlockSpecificPage';
import { CardModuleBlock as CardModuleBlockModel } from '../../../../declarations/models/blocks/CardModuleBlock';
import { CardMediaRatio } from '../../../../declarations/models/CardSize';
import { useFormConfiguration } from '../../../../components/forms/Form';
import { OutlinedContainer } from '../../../../components/OutlinedContainer';

export const CardModuleBlockSizeSelector: FC = () => {
  const { blockPath } = useCurrentBlock();
  const { t: tComponents } = useTranslation('components');
  const config = useFormConfiguration();

  /*
  const { field: cardSize } = useController<
    BlockSpecificPage<CardModuleBlockModel>,
    `${typeof blockPath}.settings.size`
  >({
    name: `${blockPath}.settings.size`,
  });
  */

  const { field: cardMediaRatio } = useController<
    BlockSpecificPage<CardModuleBlockModel>,
    `${typeof blockPath}.settings.mediaRatio`
  >({
    name: `${blockPath}.settings.mediaRatio`,
  });

  return (
    <OutlinedContainer
      fullWidth
      column
      left
      sx={{ backgroundColor: '#fff' }}
      label={tComponents('CardModuleBlock.MediaSizeSelector.label')}>
      <FormControl fullWidth color={config.color}>
        <RadioGroup
          sx={{ marginBottom: '0px' }}
          row
          {...cardMediaRatio}
          value={cardMediaRatio.value || ''}
          defaultValue=''
          onClick={(e) => e.stopPropagation()}>
          <FormControlLabel
            control={<Radio size='small' />}
            label={tComponents(`CardModuleBlock.MediaSizeSelector.undefined`)}
            value=''
          />
          {[
            CardMediaRatio.FREE,
            CardMediaRatio.R_3_2,
            CardMediaRatio.R_4_3,
            CardMediaRatio.R_16_9,
            CardMediaRatio.R_1_1,
            CardMediaRatio.R_3_4,
            CardMediaRatio.R_2_3,
          ].map((sizeOption) => (
            <FormControlLabel
              key={sizeOption}
              control={<Radio size='small' />}
              label={tComponents(`CardModuleBlock.MediaSizeSelector.${sizeOption}`)}
              value={sizeOption}
            />
          ))}
        </RadioGroup>
        {/*  
      <FormLabel>{tComponents(`CardModuleBlock.CardSizeSelector.label`)}</FormLabel>
      <RadioGroup row {...cardSize} value={cardSize.value || ''} defaultValue='' onClick={(e) => e.stopPropagation()}>
        <FormControlLabel
          control={<Radio size='small' />}
          label={tComponents(`CardModuleBlock.CardSizeSelector.undefined`)}
          value=''
        />
        {[CardSize.SMALL, CardSize.MEDIUM, CardSize.LARGE].map((sizeOption) => (
          <FormControlLabel
            key={sizeOption}
            control={<Radio size='small' />}
            label={tComponents(`CardModuleBlock.CardSizeSelector.${sizeOption}`)}
            value={sizeOption}
          />
        ))}
      </RadioGroup>
      */}
      </FormControl>
    </OutlinedContainer>
  );
};

export default CardModuleBlockSizeSelector;
